import { render, staticRenderFns } from "./LoginSeller.vue?vue&type=template&id=228e4f5e&scoped=true"
import script from "./LoginSeller.vue?vue&type=script&lang=js"
export * from "./LoginSeller.vue?vue&type=script&lang=js"
import style0 from "./LoginSeller.vue?vue&type=style&index=0&id=228e4f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e4f5e",
  null
  
)

export default component.exports